import { z } from 'zod'

export const schoolSearchParamsSchema = z.object({
  query: z.string().optional(),
  state: z.string().length(2, 'State must be a 2-letter code').optional(),
  division: z.string().optional(),
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(100).default(20),
  sortBy: z.enum(['name', 'division', 'state']).default('name'),
  sortOrder: z.enum(['asc', 'desc']).default('asc'),
})

export type SchoolSearchParams = z.infer<typeof schoolSearchParamsSchema>
